export enum MixpanelRealtimeContext {
  ORDER,
  RFQ,
  USER,
  COMPANY,
  DASHBOARD,
  EMPTY,
  SHIPMENT,
}
